<template>
  <div class="py-4 col-md-12 px-0">
    <div class="row no-gutters">
      <div class="col-lg-9">
        <div class="row no-gutters mb-3">
          <!-- イベント情報 -->
          <!-- PC -->
          <template v-if="!isMobileBreakpoint">
          <div class="catalog-info-area p-2 col-lg-6">
            <p class="order-no px-1 mb-2"><trans-text i18nKey="ui['6'][1]" />: {{event.name}}</p>
            <div class="row no-gutters">
              <div class="col-7">
                <table class="table-info w-100">
                  <tr>
                    <th><trans-text i18nKey="ui['6'][2]" /></th>
                    <td><trans-text i18nKey="ui['6'][3]" :replaceData="{quantity:totalCount}" /></td>
                  </tr>
                  <tr>
                    <th><trans-text i18nKey="ui['6'][4]" /></th>
                    <td>{{event.end_date_disp}}</td>
                  </tr>
                </table>
              </div>
              <div class="col-5 pl-1">
                <div class="price-info d-flex flex-column h-100">
                  <div class="price-label">
                    <trans-text i18nKey="ui['6'][5]" />
                  </div>
                  <div class="price-value flex-grow-1 text-right">
                    <trans-text i18nKey="ui['6'][6]" :replaceData="{money:totalPrice}" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          </template>
          <!-- Mobile -->
          <template v-else>
            <div class="catalog-info-area-mobile col-12">
              <p class="order-no px-1 mb-0 w-100"><trans-text i18nKey="ui['6'][1]" />: {{event.name}}</p>
            </div>
            <div class="catalog-info-area-mobile offset-1 col-10">
              <div class="row no-gutters">
                <div class="col-7">
                  <table class="table-info w-100">
                    <tr>
                      <th><trans-text i18nKey="ui['6'][2]" /></th>
                      <td><trans-text i18nKey="ui['6'][3]" :replaceData="{quantity:totalCount}" /></td>
                    </tr>
                    <tr>
                      <th><trans-text i18nKey="ui['6'][4]" /></th>
                      <td>{{event.end_date_disp}}</td>
                    </tr>
                  </table>
                </div>
                <div class="col-5 price-info-wrap" style="">
                  <div class="price-info d-flex flex-column h-100" style="">
                    <div class="price-label flex-grow-1">
                      <trans-text i18nKey="ui['6'][5]" />
                    </div>
                    <div class="price-value text-right">
                      <trans-text i18nKey="ui['91'][3]"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>

          <!-- イベント操作 -->
          <!-- PC -->
          <template v-if="!isMobileBreakpoint">
          <div class="col-lg-6 pl-2 catalog-operation-area">
            <div class="d-flex flex-column h-100">
              <!-- 買い物かごへ -->
              <div class="mb-auto w-100 text-right">
                <router-link tag="button" :to="{ name: 'mypage::event::cart', query: {back_path:$route.path} }" type="button" class="btn btn-lg btn-warning btn-seque-cart py-1">
                  <trans-text i18nKey="ui['6'][11]"/>
                </router-link>
              </div>
              <!-- ページネーション -->
              <div class="w-100 px-4">
                <div class="d-flex align-items-center catalog-nav">
                  <div class="prev flex-grow-1" >
                    <button type="button" class="w-100 page-link py-2 px-1" @click="sequePrevPage"><i class="fa fa-caret-left" aria-hidden="true"></i> <trans-text i18nKey="ui['6'][7]" /></button>
                  </div>
                  <div class="mx-1 flex-grow-1">
                    <ul class="pagination catalog-nav mb-0 d-flex justify-content-around align-items-center">
                      <li class="page-item page-no" v-for="item in pageNationList">
                        <router-link :class="{current:item.current}" :to="{ query: { firstCategoryId: $route.query.firstCategoryId,secondCategoryId: $route.query.secondCategoryId,thirdCategoryId: $route.query.thirdCategoryId,page:item.no }}" append class="page-link">{{item.no}}</router-link>
                      </li>
                    </ul>
                  </div>
                  <div class="next flex-grow-1">
                    <button type="button" class="w-100 page-link py-2 px-1" @click="sequeNextPage"><trans-text i18nKey="ui['6'][8]" /> <i class="fa fa-caret-right" aria-hidden="true"></i></button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Mobile -->
          </template>
          <template v-else>
            <div class="mt-3 col-12 catalog-operation-area-mobile catalog-operation-area">
              <div class="row mx-1-gutters">
                <div class="col">
                  <div class="mb-auto w-100 text-right">
                    <router-link tag="button" class="btn btn-lg btn-warning btn-seque-cart py-2" :to="{ name: 'mypage::event::cart', query: {back_path:$route.path} }" >
                      <trans-text i18nKey="ui['6'][11]"/>
                    </router-link>
                  </div>
                </div>
                <div class="col">
                  <button class="btn btn-lg btn-success btn-category py-2" @click="showCategoryPopover" ref="btnCategory">
                    <trans-text i18nKey="ui['6'][12]"/>
                  </button>

                </div>

              </div>
              <div class="mt-3 d-flex flex-column h-100">
                <!-- 買い物かごへ -->


                <!-- ページネーション -->
                <div class="w-100 px-4">
                  <div class="d-flex align-items-center catalog-nav">
                    <div class="prev flex-grow-1" >
                      <button type="button" class="w-100 page-link py-2 px-1" @click="sequePrevPage"><i class="fa fa-caret-left" aria-hidden="true"></i> <trans-text i18nKey="ui['6'][7]" /></button>
                    </div>
                    <div class="mx-1 flex-grow-1">
                      <ul class="pagination catalog-nav mb-0 d-flex justify-content-around align-items-center">
                        <li class="page-item page-no" v-for="item in pageNationList">
                          <router-link :class="{current:item.current}" :to="{ query: { firstCategoryId: $route.query.firstCategoryId,secondCategoryId: $route.query.secondCategoryId,thirdCategoryId: $route.query.thirdCategoryId,page:item.no }}" append class="page-link">{{item.no}}</router-link>
                        </li>
                      </ul>
                    </div>
                    <div class="next flex-grow-1">
                      <button type="button" class="w-100 page-link py-2 px-1" @click="sequeNextPage"><trans-text i18nKey="ui['6'][8]" /> <i class="fa fa-caret-right" aria-hidden="true"></i></button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </template>

        </div>


        <!-- 写真一覧 -->
        <div class="row mx-1-gutters">
          <component :is="photoComponent(photo)" :photo="photo" :cart="cart" v-for="photo in filteredPhotosPagination" :key="photo.id" @addCarPhoto="addCarPhoto" @removeCartPhoto="removeCartPhoto" @showPhotoImageModal="showPhotoImageModal">
          </component>
        </div>

        <!-- 下部ページネーション -->
          <!-- Mobile -->

        <template v-if="isMobileBreakpoint">
          <div class="row no-gutters mb-3">
            <div class="mt-3 col-12 catalog-operation-area-mobile catalog-operation-area">
              <div class="mt-3 d-flex flex-column h-100">
                <!-- 買い物かごへ -->
                <!-- ページネーション -->
                <div class="w-100 px-4">
                  <div class="d-flex align-items-center catalog-nav">
                    <div class="prev flex-grow-1" >
                      <button type="button" class="w-100 page-link py-2 px-1" @click="sequePrevPage"><i class="fa fa-caret-left" aria-hidden="true"></i> <trans-text i18nKey="ui['6'][7]" /></button>
                    </div>
                    <div class="mx-1 flex-grow-1">
                      <ul class="pagination catalog-nav mb-0 d-flex justify-content-around align-items-center">
                        <li class="page-item page-no" v-for="item in pageNationList">
                          <router-link :class="{current:item.current}" :to="{ query: { firstCategoryId: $route.query.firstCategoryId,secondCategoryId: $route.query.secondCategoryId,thirdCategoryId: $route.query.thirdCategoryId,page:item.no }}" append class="page-link">{{item.no}}</router-link>
                        </li>
                      </ul>
                    </div>
                    <div class="next flex-grow-1">
                      <button type="button" class="w-100 page-link py-2 px-1" @click="sequeNextPage"><trans-text i18nKey="ui['6'][8]" /> <i class="fa fa-caret-right" aria-hidden="true"></i></button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>

      </div>
      <!-- カテゴリ -->
      <div class="col-lg-3 pl-4" v-if="!isMobileBreakpoint">
        <div class="category-area">
          <ul class="list-group">
            <!-- 第一階層-->
            <template v-for="category in event.categories">
              <router-link tag="li" :to="{ query: { firstCategoryId: category.id }}" append class="list-group-item first-level">{{category.name}}</router-link>
              <!-- 第二階層-->
              <template v-for="category2 in category.children">
                <router-link tag="li" :to="{ query: { firstCategoryId: category.id,secondCategoryId:category2.id }}" append class="list-group-item second-level">{{category2.name}}</router-link>
                <!-- 第三階層-->
                <template v-for="category3 in category2.children">
                  <router-link tag="li" :to="{ query: { firstCategoryId: category.id,secondCategoryId:category2.id, thirdCategoryId:category3.id}}" append class="list-group-item third-level">{{category3.name}}</router-link>
                </template>
              </template>
            </template>
          </ul>
        </div>
      </div>
    </div>

    <!-- 画像拡大表示モーダル -->
    <photo-image-modal :targetPhoto="targetPhoto"
      @addCarPhoto="addCarPhoto" @removeCartPhoto="removeCartPhoto" @prevImage="prevImage" @nextImage="nextImage"
      :key="targetPhotoKey" ref="zoomModal">
    </photo-image-modal>

    <category-popover v-show="isShowCategoryPopover" ref="categoryPopover" :event="event" @selectCategory="selectCategory"></category-popover>
  </div>
</template>

<script>
  import {dd,store,app} from 'systems/imports'

  import FormPartialBase from 'extends/FormPartialBase.vue'
  import {required,email,minLength,alphaNum,sameAs} from 'systems/validators'

  import GroupHorizonPhoto from 'page/partials/Order/Catalog/GroupHorizonPhoto.vue'
  import SnapHorizonPhoto from 'page/partials/Order/Catalog/SnapHorizonPhoto.vue'
  import SnapVerticalPhoto from 'page/partials/Order/Catalog/SnapVerticalPhoto.vue'

  import PhotoImageModal from 'components/modal/PhotoImageModal.vue'
  import CategoryPopover from 'components/popover/CategoryPopover.vue'

  import Cart from 'processor/Cart'

  export default {
    extends:FormPartialBase,
    props:{
        isShowCategoryPopover:false,
        event:{},
        cart:{},
        totalPrice:0,
        totalCount:0
    },
    components: {
      GroupHorizonPhoto,
      SnapHorizonPhoto,
      SnapVerticalPhoto,
      PhotoImageModal,
      CategoryPopover,
    },
    data () {
      return {
        targetPhoto:{},
      }
    },
//    beforeRouteLeave (to, from, next) {
//      this.isShowCategoryPopover=false
//      this.$nextTick(function () {
//        next()
//      })
//    },
    mounted(){
      $(this.$refs.zoomModal.$refs.modal).on('hide.bs.modal', (e)=> {
        this.targetPhoto={}
        this.$nextTick(()=> {
          this.$Lazyload.lazyLoadHandler()
        })
      })
    },
    computed:{
      isMobileBreakpoint(){
        switch(this.$root.bootstrapBreakpoint){
          case "xl":
          case "lg":
            return false
          case "md":
          case "sm":
          case "xs":
            return true
          default:
            return null
        }
      },

      targetPhotoKey(){
        let targetPhoto = targetPhoto
        if(!targetPhoto){return null}
        return targetPhoto.id
      },


      filteredPhotos(){
        let targetCategoryids = []
        let firstCategoryId = Number(this.$route.query.firstCategoryId) || null
        let secondCategoryId = Number(this.$route.query.secondCategoryId) || null
        let thirdCategoryId = Number(this.$route.query.thirdCategoryId) || null
        let eventPhotos = this.event.photos
        let page = this.$route.query.page || 1

        if(!eventPhotos){ return []}

        if(thirdCategoryId){ targetCategoryids.push(thirdCategoryId)}
        if(app.make("_").isEmpty(targetCategoryids) && secondCategoryId){ targetCategoryids.push(secondCategoryId)}
        if(app.make("_").isEmpty(targetCategoryids) && firstCategoryId){ targetCategoryids.push(firstCategoryId)}

        this.$nextTick(()=> {
          setTimeout(()=>{
            this.$Lazyload.lazyLoadHandler()
          },50)
        })

        return app.make("_").isEmpty(targetCategoryids)? eventPhotos :
          app.make("_").filter(eventPhotos, function(o) {
          return !app.make("_").isEmpty(app.make("_").intersection(o.category.included_category_ids,targetCategoryids));
        })
      },
      filteredPhotosPagination(){
        let page = this.$route.query.page || 1
        return this.filteredPhotos.slice(page*24-24,page*24)
      },
      pageNationList(){
        let page = this.$route.query.page || 1
        let list = []
        for(let i=page-2;i<page;i++ ){
          if(i<1){continue}
          list.push({"no":i})
        }
        list.push({"no":page,"current":true})
        while(list.length<5){
          if(page > this.filteredPhotos.length / 24){ break }
          page++
          list.push({"no":page})
        }
        while(list.length<5){
          let no =  list[0].no - 1
          if(no<1){ break }
          list.unshift({"no":no})
        }
        return list
      },
    },
    methods:{
      showCategoryPopover(){
        this.$emit("toggleIsShowCategoryPopover")


        this.$nextTick(function () {
          new Tether({
            element: this.$refs.categoryPopover.$refs.popover,
            target: this.$refs.btnCategory,
            attachment: 'top right',
            targetAttachment: 'bottom right',
          });
        })
      },
      selectCategory(){
        this.$emit("selectCategory")
      },
      showPhotoImageModal(photo){
        this.targetPhoto = photo

        let isVertically = app.make("_").first(this.targetPhoto.photo_thumbnails).is_vertically
        let photoTypeCode = app.make("_").first(this.targetPhoto.photo_types).code

        this.$nextTick(function () {
            $(this.$refs.zoomModal.$refs.modal).modal({})
        })
      },
      photoComponent(photo){
        let photoTypeCode = app.make("_").first(photo.photo_types).code
        let isVertically = app.make("_").first(photo.photo_thumbnails).is_vertically

        switch(String(photoTypeCode)){
          case "1": //スナップ
              return isVertically? "SnapVerticalPhoto" : "SnapHorizonPhoto"
          case "2": //集合写真
            return isVertically? "SnapVerticalPhoto" : "GroupHorizonPhoto"
        }
      },
      prevImage(photo){
        let photoIndex = app.make("_").findIndex(this.filteredPhotos, function(o) { return o.id == photo.id; })
        photoIndex--;
        if(photoIndex<0){ photoIndex = (this.filteredPhotos.length - 1)}
        this.targetPhoto = this.filteredPhotos[photoIndex]
        let isVertically = app.make("_").first(this.targetPhoto.photo_thumbnails).is_vertically
        this.$router.push({query: Object.assign({},this.$route.query, {page:Math.floor(photoIndex / 24) + 1}) })

      },
      nextImage(photo){
        let photoIndex = app.make("_").findIndex(this.filteredPhotos, function(o) { return o.id == photo.id; })
        photoIndex++;
        if(photoIndex>=this.filteredPhotos.length){ photoIndex = 0 }
        this.targetPhoto = this.filteredPhotos[photoIndex]
        this.$router.push({query: Object.assign({},this.$route.query, {page:Math.floor(photoIndex / 24) + 1}) })
      },
      addCarPhoto(photo){
        Cart.addCartPhoto({cart_id:this.cart.id,photo_id:photo.id})
          .then((res) => {
            if (res.status === "ng") {
              this.apiErrorI18nKeyByCart = res.apiErrorI18nKey
              return
            }
            photo.cart_photos.push(res.data.cart_photo)
            this.$emit("refleshTotal")
          })

      },
      removeCartPhoto(photo){
        let cartPhoto = app.make("_").first(photo.cart_photos)
        Cart.removeCartPhoto({cart_id:this.cart.id,cart_photo_id:cartPhoto.id})
          .then((res) => {
            if (res.status === "ng") {
              this.apiErrorI18nKeyByCart = res.apiErrorI18nKey
              return
            }
            let index =app.make("_").findIndex(photo.cart_photos,(o)=>o.id === cartPhoto.id)
            photo.cart_photos.splice(index, 1)
            this.$emit("refleshTotal")
          })
      },
      sequePrevPage(){
        let page = Number(this.$route.query.page) || 1
        if(page <= 1){ return }
        page--
        this.$router.push({query: Object.assign({},this.$route.query, {page}) })

      },
      sequeNextPage(){
        let page = Number(this.$route.query.page) || 1
        if(page > this.filteredPhotos.length / 24){ return }
        page++
        this.$router.push({query: Object.assign({},this.$route.query, {page}) })
      },

    }
  }

</script>

<style lang="scss" scoped>

  //
  .catalog-info-area-mobile{
    font-size: 0.8em;
    .order-no{
      font-weight: bold;
      background-color: #82ba1d;
      color: #fff;
    }
    .table-info{
      background-color: #fff;
      border:1px solid #8CBF42;
      th{
        padding:1px 4px;
        color:#8CBF42;
        border:1px solid #8CBF42;
      }
      td{
        padding:1px 4px;
        border:1px solid #8CBF42;
      }
    }
    .price-info-wrap{
      border:1px solid #ec4200;
      background-color: #fff;
      position: relative;
      .price-info{
        position: absolute;
        top:0;
        left:0;
        bottom: 0;
        right:0;
        width:100%;
        height:100%;
        .price-label{
          padding:1px 4px 0 4px;
          color: #ec4200;
        }
        .price-value{
          font-size: .7rem;
          padding:0 4px;
        }
      }
    }

  }

  .catalog-info-area{
    border: 1px solid #919191;
    background-color: #fff;
    font-size: 0.8rem;

    .order-no{
      font-weight: bold;
      background-color: #82ba1d;
      color: #fff;
    }
    .table-info{
      background-color: #fff;
      border:1px solid #8CBF42;
      th{
        padding:1px 4px;
        color:#8CBF42;
        border:1px solid #8CBF42;
      }
      td{
        padding:1px 4px;
        border:1px solid #8CBF42;
      }
    }
    .price-info{
      border:1px solid #ec4200;
      .price-label{
        padding:1px 4px 0 4px;
        color: #ec4200;
      }
      .price-value{
        font-size: .8rem;
        padding:0 4px;
      }

    }
  }
  //
  .catalog-operation-area {
    .btn-seque-cart {
      padding-left: 2.5rem;
      position: relative;
      &:before {
        font-family: FontAwesome;
        content: '\f291';
        font-size: 1.2rem;
        color: #fff;
        position: absolute;
        top: 50%;
        transform: translateY(-50%) translateX(0);
        left: 5%;
      }
    }
    .catalog-nav {
      .prev, .next {
        font-size:0.9rem;
        border-radius: 0;
        button {
          cursor: pointer;
          border-radius: 0;
          color: #fff;
          background-color: #f79918;
        }
      }
      .page-no {
        margin: 0 5px;
        a {
          border-radius: 0;
          border: 1px solid #f79918;
          color: #f79918;
          font-weight: bold;
          font-size: 0.8rem;
          padding: .3rem .4rem;
          &.current{
            background-color: #f79919;
            color:#fff;
          }
        }
      }

    }
  }

  .catalog-operation-area-mobile {
    .btn-seque-cart {
      width: 95%;
      font-size:.8rem;
      padding-left: 2rem;
      &:before {
        font-size: 1.2rem;
      }
    }
    .btn-category {
      font-size:.8rem;
      width:95%;
      padding-left: 2rem;
      position: relative;
      &:before {
        font-family: FontAwesome;
        content: '\f0b0';
        font-size: 1.2rem;
        color: #fff;
        position: absolute;
        top: 50%;
        transform: translateY(-50%) translateX(0);
        left: 5%;
      }
    }
  }

  .category-area{
    .list-group-item{
      border-radius: 0 !important;
      cursor: pointer;
      font-size: 0.8rem;
      padding:8px 16px;
      &.first-level {
        color: #453e4f;
        font-weight: bold;
        background-color: #c1df86;
        position: relative;
        &:after{
          font-family: FontAwesome;
          content: '\f054';
          font-size:1.2rem;
          color: #81ba1c;
          position: absolute;
          top: 50%;
          transform: translateY(-50%) translateX(0);
          right: 5%;
        }
      }
      &.second-level {
        color: #5f5f5e;
        background-color: #f8ffeb;
      }
      &.third-level {
        color: #5f5f5e;
        background-color: #f8ffeb;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// PageContent.vue?5be62466